/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import WebpackerReact from 'webpacker-react';
import PhoneInput from 'react-phone-input-2';
import PasswordInput from '../components/PasswordInput';
import StyledTextField from '../components/common/StyledTextField';
import PhoneNumberInput from '../components/common/PhoneNumberInput';
import AskQuestion from '../components/AskQuestion';
import ProjectFeedbacks from '../components/ProjectFeedbacks';
import ProposalFeedbacks from '../components/ProposalFeedbacks';
import ScheduleInterviewModal from '../components/ScheduleInterviewModal';
import ScheduleInterviewConsultant from '../components/ScheduleInterviewConsultant';
import DeclineProposal from '../components/DeclineProposal';
import AcceptProposal from '../components/AcceptProposal';
import SubmitToEmployer from '../components/SubmitToEmployer';
import ProposalResponse from '../components/ProposalResponse';
import ShareResource from '../components/ShareResource';
import CopyLink from '../components/common/CopyLink';
import NotFound from '../components/NotFound';
import CreateProposal from '../components/Proposals/CreateProposal';
import ShortDescription from '../components/ShortDescription';
import TextAreaMaxWords from '../components/common/TextAreaMaxWords';
import YesNoNumberInput from '../components/common/YesNoNumberInput';
import ConfirmSubmitProposal from '../components/common/ConfirmSubmitProposal';
import ModalTrigger from '../components/common/ModalTrigger';
import ProjectWorkLocationQuestion from '../components/ProjectWorkLocationQuestion';
import TitleTabBar from '../components/Proposals/TitleTabBar';
import ProjectIndexContainer from '../components/ProjectIndexContainer';
import ConsultantProjectIndexContainer from '../components/ConsultantProjectIndexContainer';
import ProjectIndexListGroup from '../components/ProjectIndexListGroup';
import MarkOnHold from '../components/MarkOnHold';
import OnboardingFlow from '../components/ConsultantOnboarding/OnboardingFlow';
import UserSection from '../components/ConsultantProfile/UserSection';
import ConsultantProfile from '../components/ConsultantProfile';
import AnswersContainer from '../components/AnswersContainer';
import Opportunity from '../components/Opportunity';
import ToggleUpcomingNotification from '../components/ToggleUpcomingNotification';
import Registration from '../components/Registration';
import EmployerSignupForm from '../components/Registration/EmployerSignupForm';
import SignInForm from '../components/SignInForm';
import EmployerProjectIndexContainer from '../components/EmployerProjectIndexContainer';
import HowCloraWorksForEmployers from '../components/HowCloraWorksForEmployers';
import InterestInProjectSubmitted from '../components/InterestInProjectSubmitted';
import ReferralsIndexContainer from '../components/ReferralsIndexContainer';
import ReferralTrigger from '../components/ReferralTrigger';
import ReferralOptions from '../components/ReferralsIndexContainer/ReferralOptions';
import ReadOnlyInputWithEditLink from '../components/ReadOnlyInputWithEditLink';
import ProjectShare from '../components/ProjectShare';
import ConsultantReferralForm from '../components/ConsultantReferralForm';
import RepProjectApplicationActions from '../components/RepProjectApplicationActions';
import ConsultantInterest from '../components/ConsultantInterest';
import ConsultantCreateConsultantInterest from '../components/ConsultantCreateConsultantInterest';
import RecommendationsReceivedModal from '../components/RecommendationsReceivedModal';
import DocumentUpload from '../components/DocumentUpload';
import ProjectLead from '../components/ProjectLead';
import AddProposalPastRoles from '../components/AddProposalPastRoles';
import AddLocationOnProposal from '../components/AddLocationOnProposal';
import ProfileCompletion from '../components/common/ProfileCompletion';
import SubmitProposal from '../components/SubmitProposal';
import ConsultantCard from '../components/ConsultantCard';
import EmptyFeaturedProfiles from '../components/EmptyFeaturedProfiles';
import ProjectPublishedModal from '../components/ProjectPublishedModal';
import ProjectStatusBar from '../components/ProjectStatusBar';
import ProjectStatusActions from '../components/ProjectStatusActions';
import Invoice from '../components/Invoice';
import DisplayLineItem from '../components/common/DisplayLineItem';
import InvoiceHeader from '../components/Invoice/InvoiceHeader';
import ProjectNameSummaryModal from '../components/ProjectNameSummaryModal';
import RequestEditsInvoice from '../components/RequestEditsInvoice/RequestEditsInvoice';
import InvoicesWalkthrough from '../components/InvoicesWalkthrough';
import ExecuteAgreementForProject from '../components/ExecuteAgreementForProject';
import WorkCompletedForProject from '../components/WorkCompletedForProject';
import EditInvoiceRate from '../components/EditInvoiceRate';
import NotInvoicingModal from '../components/NotInvoicingModal';
import Review from '../components/Review';
import ConsultantSearchCard from '../components/Search/ConsultantSearchCard';
import SearchFilterMenu from '../components/Search/SearchFilterMenu';
import SearchContainer from '../components/Search/SearchContainer';
import EmployerInvitesConsultantToProjectModal from '../components/EmployerInvitesConsultantToProjectModal';
import ReviewIndexPage from '../components/ReviewIndexPage';
import ContactSupportBanner from '../components/ContactSupportBanner';
import AutosuggestInput from '../components/common/AutosuggestInput';
import ProjectInvitationCard from '../components/ProjectInvitationCard';
import ProjectInvitationAskQuestion from '../components/ProjectInvitationAskQuestion';
import ProjectInvitationDecline from '../components/ProjectInvitationDecline';
import ProjectPermissions from '../components/ProjectPermissions';
import LikeDislikeProject from '../components/common/LikeDislikeProject';
import AdminCreateInvoiceModal from '../components/AdminCreateInvoiceModal';
import NPSModal from '../components/NPSModal';
import EmployerReferralModal from '../components/EmployerReferralModal';
import AddCoworkersModal from '../components/AddCoworkersModal';
import AddProject from '../components/AddProject';
import ConsultantTalentContainer from '../components/ConsultantTalentContainer';
import HireAgain from '../components/HireAgain';
import ProfileSuggestions from '../components/common/ProfileSuggestions';
import ProposalInterviews from '../components/ProposalInterviews';
import EmployerInterviews from '../components/EmployerInterviews';
import InterviewPanel from '../components/InterviewPanel';
import ProfileSuggestionModal from '../components/ProfileSuggestionModal';
import NavBar from '../components/ProjectDetails/NavBar';
import ProjectName from '../components/ProjectDetails/ProjectName';
import ProjectExpertise from '../components/ProjectDetails/ProjectExpertise';
import ProjectExpertisePriority from '../components/ProjectDetails/ProjectExpertisePriority';
import ProjectDetails from '../components/ProjectDetails';
import UserViewsTable from '../components/UserViewsTable';
import InfoTooltip from '../components/common/InfoTooltip';
import ConsultantReview from '../components/ConsultantReview';
import ConfirmModal from '../components/ConfirmModal';
import FeedbackHistory from '../components/FeedbackHistory';
import FeedbackHistoryRow from '../components/FeedbackHistory/FeedbackHistoryRow';
import TypeformModal from '../components/TypeformModal';
import ProjectRepAssigned from '../components/ProjectRepAssigned/ProjectRepAssigned';
import ErrorMessageField from '../components/common/ErrorMessageField';
import ConsultantAgreementModal from '../components/ConsultantAgreementModal';
import FeaturedProfiles from '../components/FeaturedProfiles';
import FilterTag from '../components/common/FilterTag';
import ProjectNav from '../components/ProjectNav';
import RecommendedConsultantCard from '../components/RecommendedConsultantCard';
import RegistrationModal from '../components/RegistrationModal';
import SavedFeaturedProfile from '../components/SavedFeaturedProfile';
import FeaturedProfilesCarousel from '../components/FeaturedProfilesCarousel';
import ProjectClosure from '../components/ProjectClosure';
import ProjectStatusBox from '../components/ProjectStatusBox/ProjectStatusBox';
import StatusChange from '../components/StatusChange';
import ProjectEmploymentType from '../components/common/ProjectEmploymentType';
import CompanyMerge from '../components/CompanyMerge';
import ProjectLogisticsInfo from '../components/common/ProjectLogisticsInfo';
import SignIn from '../components/SignIn';
import NextSteps from '../components/ProjectNav/NextSteps';
import AlgoliaInstantSearch from '../components/FeaturedProfiles/AlgoliaInstantSearch';
import GetStartedCTA from '../components/common/GetStartedCTA';
import Wall from '../components/Registration/Wall';
import Resume from '../components/common/Resume';
import CompanyRegistrationDropdown from '../components/common/CompanyRegistrationDropdown';
import CreateInvoiceDropdown from '../components/CreateInvoiceDropdown';
import ViewAdHocInvoiceDropdown from '../components/ViewAdHocInvoiceDropdown';
import ProposalQuestion from '../components/common/ProposalQuestion';
import ProposalShow from '../components/common/ProposalShow/ProposalShow';
import MarketingMessages from '../components/MarketingMessages';
import UserFavorites from '../components/UserFavorites';
import ProjectSearchContainer from '../components/ProjectSearchContainer';
import ConsultantSearchContainer from '../components/ConsultantSearchContainer';
import InterviewQuestions from '../components/InterviewQuestions';

WebpackerReact.setup({
  PasswordInput,
  StyledTextField,
  PhoneInput,
  PhoneNumberInput,
  AskQuestion,
  ProjectFeedbacks,
  ProposalFeedbacks,
  ScheduleInterviewModal,
  ScheduleInterviewConsultant,
  DeclineProposal,
  AcceptProposal,
  SubmitToEmployer,
  ProposalResponse,
  ShareResource,
  CopyLink,
  NotFound,
  CreateProposal,
  ShortDescription,
  TextAreaMaxWords,
  YesNoNumberInput,
  ConfirmSubmitProposal,
  ModalTrigger,
  ProjectWorkLocationQuestion,
  TitleTabBar,
  ProjectIndexContainer,
  ConsultantProjectIndexContainer,
  ProjectIndexListGroup,
  MarkOnHold,
  OnboardingFlow,
  UserSection,
  ConsultantProfile,
  AnswersContainer,
  Opportunity,
  ToggleUpcomingNotification,
  Registration,
  EmployerSignupForm,
  SignInForm,
  EmployerProjectIndexContainer,
  HowCloraWorksForEmployers,
  InterestInProjectSubmitted,
  ReferralsIndexContainer,
  ReferralTrigger,
  ReferralOptions,
  ReadOnlyInputWithEditLink,
  ProjectShare,
  RepProjectApplicationActions,
  ConsultantInterest,
  ConsultantCreateConsultantInterest,
  ConsultantReferralForm,
  DocumentUpload,
  ProjectLead,
  AddProposalPastRoles,
  AddLocationOnProposal,
  ProfileCompletion,
  SubmitProposal,
  ConsultantCard,
  EmptyFeaturedProfiles,
  ProjectPublishedModal,
  ProjectStatusBar,
  ProjectStatusActions,
  Invoice,
  DisplayLineItem,
  InvoiceHeader,
  ProjectNameSummaryModal,
  RequestEditsInvoice,
  InvoicesWalkthrough,
  ExecuteAgreementForProject,
  WorkCompletedForProject,
  EditInvoiceRate,
  NotInvoicingModal,
  Review,
  SearchContainer,
  ConsultantSearchCard,
  EmployerInvitesConsultantToProjectModal,
  SearchFilterMenu,
  ReviewIndexPage,
  ContactSupportBanner,
  AutosuggestInput,
  ProjectInvitationCard,
  ProjectInvitationAskQuestion,
  ProjectInvitationDecline,
  ProjectPermissions,
  LikeDislikeProject,
  AdminCreateInvoiceModal,
  NPSModal,
  EmployerReferralModal,
  AddCoworkersModal,
  AddProject,
  ConsultantTalentContainer,
  HireAgain,
  ProfileSuggestions,
  ProposalInterviews,
  EmployerInterviews,
  InterviewPanel,
  ProfileSuggestionModal,
  NavBar,
  ProjectDetails,
  UserViewsTable,
  InfoTooltip,
  ConsultantReview,
  ConfirmModal,
  FeedbackHistory,
  FeedbackHistoryRow,
  TypeformModal,
  ProjectRepAssigned,
  ErrorMessageField,
  StatusChange,
  ConsultantAgreementModal,
  FeaturedProfiles,
  SavedFeaturedProfile,
  FeaturedProfilesCarousel,
  ProjectClosure,
  FilterTag,
  ProjectNav,
  ProjectStatusBox,
  RecommendedConsultantCard,
  RegistrationModal,
  ProjectEmploymentType,
  CompanyMerge,
  ProjectLogisticsInfo,
  SignIn,
  NextSteps,
  AlgoliaInstantSearch,
  GetStartedCTA,
  Wall,
  Resume,
  CompanyRegistrationDropdown,
  CreateInvoiceDropdown,
  ViewAdHocInvoiceDropdown,
  ProposalQuestion,
  ProposalShow,
  MarketingMessages,
  ProjectExpertise,
  ProjectExpertisePriority,
  RecommendationsReceivedModal,
  ProjectName,
  UserFavorites,
  ProjectSearchContainer,
  ConsultantSearchContainer,
  InterviewQuestions,
});
